import { render } from "./home-three-popular.vue?vue&type=template&id=672d958d"
import script from "./home-three-popular.vue?vue&type=script&lang=js"
export * from "./home-three-popular.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__